import { Card, Spin, Tag } from "antd";
import { useContext, useEffect, useState } from "react";
import EditButton from "../../../components/buttons/edit";
import {
    InlineContainer,
    SecondaryTextJustify,
    TitleHeader,
    VerticalContainer,
} from "../../../components/styled";
import ViagemForm from "../../../components/viagens/form";
import ViewContainer from "../../../components/view_container";
import { UserContext } from "../../../context";
import { SITUACOES } from "../../../models/solicitacoes";
import { getViagem, updateViagem } from "../../../services/viagens";

const situacoesStyle = {
  LANÇADO: "yellow",
  CANCELADO: "red",
  FINALIZADO: "green",
};

const prioridadeStyle = {
  ELETIVO: "#73d13d",
  PRIORITARIO: "#fadb14",
  URGENCIA: "#cf1322",
};

export default function EditViagem({ computedMatch }) {
  const [error, setError] = useState();
  const [viagem, setViagem] = useState();
  const [loading, setLoading] = useState(false);
  const [viewMode, setViewMode] = useState(true);
  const [podeEditar, setPodeEditar] = useState(true);
  const user = useContext(UserContext);
  const { params } = computedMatch;
  const onFinish = async (values) => {
    try {
      setLoading(true);
      await updateViagem(viagem, values);
    } catch (err) {
      console.log(err);
      setError(err.error);
    } finally {
      setLoading(false);
    }
  };

  const handleViagem = async () => {
    const data = await getViagem(params.id);
    if(data.status == SITUACOES.FINALIZADO || data.status == SITUACOES.CANCELADO){
        setPodeEditar(false)
    }
    setViagem(data);
  };

  useEffect(() => {
    handleViagem();
  }, []);

  return (
    <>
      {viagem ? (
        <VerticalContainer>
          <InlineContainer>
            <TitleHeader>{`Nº - ${viagem.id}`}</TitleHeader>
            {user?.type !== "CLINICA" && podeEditar && (
              <EditButton viewMode={viewMode} setViewMode={setViewMode} />
            )}
          </InlineContainer>
          <Card
            title="Informações"
            style={{ marginTop: "-20px", borderColor: "white" }}
          >
            <SecondaryTextJustify>
              {" "}
              Situação:{" "}
              <Tag color={situacoesStyle[viagem.status]}>
                {viagem.status}
              </Tag>
            </SecondaryTextJustify>
            {viagem.motivo_cancelamento &&
              viagem.status === SITUACOES.CANCELADO && (
                <SecondaryTextJustify>
                  Motivo do cancelamento: {viagem.motivo_cancelamento}
                </SecondaryTextJustify>
              )}
            <SecondaryTextJustify>
              {" "}
              Lançamento: {viagem?.created_by?.name}
            </SecondaryTextJustify>
            <SecondaryTextJustify>
              {" "}
              Prioridade:{" "}
              <Tag color={prioridadeStyle[viagem.prioridade]}>
                {viagem.prioridade}
              </Tag>
            </SecondaryTextJustify>{" "}
            {viagem.situacao === "CANCELADO" && (
              <SecondaryTextJustify>
                Cancelamento: {viagem?.canceled_by?.name}
              </SecondaryTextJustify>
            )}
          </Card>
          <ViewContainer item={viagem}>
            <ViagemForm
              initialValues={{ ...viagem }}
              onFinish={onFinish}
              error={error}
              setError={setError}
              loading={loading}
              viewMode={viewMode}
            />
          </ViewContainer>
        </VerticalContainer>
      ) : (
        <Spin />
      )}
    </>
  );
}
